import React, { createContext, useState, useEffect, useContext } from 'react';
import { auth } from '../services/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { userService } from '../services/db';

// Create auth context
const AuthContext = createContext();

// Auth provider component
export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Monitor auth state
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Get additional user data from Firestore
        const userData = await userService.getById(user.uid);
        setCurrentUser(userData);
      } else {
        setCurrentUser(null);
      }
      setLoading(false);
    });
    
    return unsubscribe;
  }, []);
  
  // Login function (now just passes to the service)
  const login = async (email, password) => {
    return userService.login(email, password);
  };
  
  // Google sign in function
  const signInWithGoogle = async () => {
    return userService.signInWithGoogle();
  };
  
  // Register function
  const register = async (userData) => {
    return userService.register(userData);
  };
  
  // Logout function
  const logout = () => {
    return userService.logout();
  };
  
  // Context value
  const value = {
    currentUser,
    loading,
    login,
    signInWithGoogle,
    register,
    logout
  };
  
  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

// Custom hook to use auth context
export function useAuth() {
  return useContext(AuthContext);
} 